<template>
  <div>
    <div class="locationcity">
      <div class="pt-4 w-full">
        <b-button
          type="button"
          class="back-btn flex items-center ml-3 mb-4"
          @click="showProfile"
        >
          <feather-icon
            icon="ChevronLeftIcon"
            svgClasses=""
            @click="showProfile"
          />
          Back
        </b-button>
        <div class="md:flex">
          <div class="md:w-1/2 lg:w-1/2 w-full pt-4">
            <p class="input-title-black">First Name</p>
            <base-input
              placeholder="Enter your first name"
              class="cust-form-border"
              name="location"
              v-model="selectedUser.firstname"
              disabled
            >
            </base-input>
          </div>
          <div class="md:pl-4 lg:pl-4 ml-0 mt-4 md:w-1/2 lg:w-1/2 w-full">
            <p class="input-title-black">Last Name</p>
            <base-input
              placeholder="Enter your last name"
              class="cust-form-border"
              name="city"
              v-model="selectedUser.lastname"
              disabled
            ></base-input>
          </div>
        </div>
      </div>
    </div>
    <div class="locationcity">
      <div class="pt-4 w-full">
        <div class="md:flex">
          <div class="md:w-1/2 lg:w-1/2 w-full pt-4">
            <p class="input-title-black">Email Address</p>
            <base-input
              placeholder="Enter your email address"
              class="cust-form-border"
              name="location"
              v-model="selectedUser.email"
              disabled
            >
            </base-input>
          </div>
          <div class="md:pl-4 lg:pl-4 ml-0 mt-4 md:w-1/2 lg:w-1/2 w-full">
            <p class="input-title-black">Phone</p>
            <base-input
              placeholder="Enter your phone number"
              class="cust-form-border"
              name="city"
              v-model="selectedUser.mobile"
              disabled
            ></base-input>
          </div>
        </div>
      </div>
    </div>
    <div class="pt-4">
      <p class="input-title-black font-semibold">Age</p>

      <div
        class="mt-4 lg:grid lg:grid-cols-3 md:grid md:grid-cols-3 grid grid-cols-2 justify-between"
      >
        <div class="lg:w-1/2 md:w-1/2 w-3/4">
          <b-form-radio
            name="age"
            v-model="profileData[0].age"
            value="15-20"
            disabled
            ><p>15-20</p></b-form-radio
          >
        </div>
        <div class="lg:w-1/2 md:w-1/2 w-3/4">
          <b-form-radio
            name="age"
            v-model="profileData[0].age"
            value="20-30"
            disabled
            ><p>20-30</p></b-form-radio
          >
        </div>
        <div class="lg:w-1/2 md:w-1/2 w-3/4">
          <b-form-radio
            name="age"
            v-model="profileData[0].age"
            value="30-50"
            disabled
            ><p>30-50</p></b-form-radio
          >
        </div>

        <div class="lg:w-1/2 md:w-1/2 w-3/4">
          <b-form-radio
            name="age"
            v-model="profileData[0].age"
            value="50-70"
            disabled
            ><p>50-70</p></b-form-radio
          >
        </div>
        <div class="lg:w-4/5 md:w-4/5 w-full">
          <b-form-radio
            name="age"
            v-model="profileData[0].age"
            value="More than 70"
            disabled
            ><p>More than 70</p></b-form-radio
          >
        </div>
      </div>
    </div>
    <div class="locationcity">
      <div class="pt-4 w-full">
        <div class="md:flex">
          <div class="md:w-1/2 lg:w-1/2 w-full pt-4">
            <p class="input-title-black">Location</p>
            <base-input
              placeholder="Enter your location"
              class="cust-form-border"
              name="location"
              v-model="profileData[0].address"
              disabled
            >
            </base-input>
            <!-- , alpha_num: true  -->
          </div>
          <div class="md:pl-4 lg:pl-4 ml-0 mt-4 md:w-1/2 lg:w-1/2 w-full">
            <p class="input-title-black">City</p>
            <base-input
              placeholder="Enter your city"
              class="cust-form-border"
              name="city"
              v-model="profileData[0].city"
              disabled
            ></base-input>
          </div>
        </div>
      </div>
    </div>
    <div class="locationcity">
      <div class="pt-4 w-full">
        <div class="md:flex">
          <div class="md:w-1/2 lg:w-1/2 w-full pt-4">
            <p class="input-title-black">
              What is your Whatsapp number? (in case you have a different
              number)
            </p>
            <base-input
              placeholder="Enter your Whatsapp Number"
              class="cust-form-border"
              name="Mobile Number"
              v-model="profileData[0].whatsappNo"
              disabled
            >
            </base-input>
            <!-- , alpha_num: true  -->
          </div>
          <div class="md:pl-4 lg:pl-4 ml-0 mt-4 md:w-1/2 lg:w-1/2 w-full">
            <p class="input-title-black">Current Profession</p>
            <base-input
              placeholder="Enter your Current Profession"
              class="cust-form-border"
              name="current profession"
              v-model="profileData[0].profession"
              disabled
            ></base-input>
          </div>
        </div>
      </div>
    </div>
    <div class="locationcity">
      <div class="pt-4 w-full">
        <div class="md:flex">
          <div class="w-full pt-4">
            <p class="input-title-black">
              There are various ways you could relate to in a category, which
              one do you relate with the most currently?
            </p>

            <base-input name="Category">
              <select
                class="form-control"
                v-model="profileData[0].category"
                disabled
              >
                <option value="" disabled>Please select an option</option>
                <option value="Caregiver">Caregiver</option>
                <option value="Well Wisher of the caregiver">
                  Well Wisher of the caregiver
                </option>
                <option value="volunteer">Volunteer</option>
                <option
                  value="Healthcare Professional/Profession Caregiver/Nurse"
                >
                  Healthcare Professional/Profession Caregiver/Nurse
                </option>
                <option value="Coach">Coach</option>
                <option value="Psychologist">Psychologist</option>
                <option value="Yoga Therapist">Yoga Therapist</option>
                <option value="financial advisor">Financial Advisor</option>
                <option value="Legal Expert">Legal Expert</option>
                <option value="Intern">Intern</option>
                <option value="Other">Other</option>
              </select>
            </base-input>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-12">
      <p class="input-title-black font-semibold">
        Would you like to subscribe our newsletter?
      </p>

      <div class="mt-4 md:flex justify-between flex-wrap">
        <div class="w-1/3">
          <b-form-radio
            name="Yes2"
            v-model="profileData[0].newsletter"
            disabled
            value="yes"
            ><p>Yes</p></b-form-radio
          >
        </div>
        <div class="w-2/3">
          <b-form-radio
            name="No2"
            v-model="profileData[0].newsletter"
            disabled
            value="no"
            ><p>No</p></b-form-radio
          >
        </div>
      </div>
    </div>

    <div class="mt-12">
      <p class="input-title-black font-semibold">
        We conduct research from time to time, would you agree to take part in
        our surveys?
      </p>

      <div class="mt-4 md:flex justify-between flex-wrap">
        <div class="w-1/3">
          <b-form-radio
            name="Yes3"
            v-model="profileData[0].surveys"
            disabled
            value="yes"
            ><p>Yes</p></b-form-radio
          >
        </div>
        <div class="w-2/3">
          <b-form-radio
            name="N3o"
            v-model="profileData[0].surveys"
            disabled
            value="no"
            ><p>No</p></b-form-radio
          >
        </div>
      </div>
    </div>

    <div class="mt-12">
      <p class="input-title-black font-semibold">
        How did you get to know about us?
      </p>

      <div class="mt-4 md:flex justify-between flex-wrap">
        <div class="w-1/3 mb-2">
          <b-form-radio
            name="Family Member"
            v-model="profileData[0].platforms"
            disabled
            value="familyMember"
            ><p>From a Friend/ Family Member</p></b-form-radio
          >
        </div>
        <div class="w-1/3 mb-2">
          <b-form-radio
            name="Social Media"
            v-model="profileData[0].platforms"
            disabled
            value="socialMedia"
            ><p>Social Media</p></b-form-radio
          >
        </div>
        <div class="w-1/3">
          <b-form-radio
            name="Email1"
            v-model="profileData[0].platforms"
            disabled
            value="email"
            ><p>Email</p></b-form-radio
          >
        </div>
        <div class="w-1/3">
          <b-form-radio
            name="Other"
            v-model="profileData[0].platforms"
            disabled
            value="others"
            ><p>Other</p></b-form-radio
          >
        </div>
      </div>
    </div>

    <div class="mt-12">
      <p class="input-title-black font-semibold">
        How would you want to receive information of Caregiver Saathi?
      </p>

      <div class="mt-4 md:flex justify-between flex-wrap">
        <div class="w-3/5 mb-2">
          <b-form-radio
            name="One on One"
            v-model="profileData[0].infoThrough"
            disabled
            value="oneOnOne"
            ><p>One on One</p></b-form-radio
          >
        </div>
        <div class="w-3/5 mb-2">
          <b-form-radio
            name="Email2"
            v-model="profileData[0].infoThrough"
            disabled
            value="email"
            ><p>Email</p></b-form-radio
          >
        </div>
        <div class="w-3/5">
          <b-form-radio
            name="Whatsapp"
            v-model="profileData[0].infoThrough"
            disabled
            value="whatsapp"
            ><p>Whatsapp</p></b-form-radio
          >
        </div>
        <div class="w-3/5">
          <b-form-radio
            name="All"
            v-model="profileData[0].infoThrough"
            disabled
            value="all"
            ><p>All</p></b-form-radio
          >
        </div>
      </div>
    </div>
    <!-- <div>
      <base-button
        type="primary"
        native-type="submit"
        :disabled="isValidForm"
        class="md:px-10 lg:px-10 px-6 md:py-2 lg:py-2 py-1 border-2 text-base font-bold mt-12"
        >Update</base-button
      >
    </div> -->
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      input: "",
    };
  },
  methods: {
    showProfile() {
      this.$router.push({ name: "admin-user" });
    },
    async getProfileData() {
      let loader = this.$loading();
      try {
        let data = await this.$store.dispatch("eLearning/getProfile", {
          userId: this.selectedUser._id,
        });
        if (data.code == 200) {
          loader.close();
        }
        loader.close();
      } catch (error) {
        loader.close();
      }
    },
  },
  async created() {
    await this.getProfileData();
  },
  computed: {
    ...mapState("auth", ["selectedUser"]),
    ...mapState("eLearning", ["profileData"]),
  },
};
</script>

<style>
.p-0card > .card-body {
  padding: 0px !important;
}

.root > div > .nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  /* background: red; */
  /* border-top-width: 10px; */
  border-bottom: 4px solid #830c81;
  background-color: rgb(255, 255, 255);
  border-top: none;
  border-left: none;
  border-right: none;
  font-weight: 700;
  color: #333;
  display: flex;
  justify-content: center;
  /* background-color: antiquewhite; */
}
.root > div > .nav-tabs .nav-link {
  /* border: none !important; */
  border-radius: 0% !important;
}
.root > div > .nav-tabs .nav-item {
  flex-grow: 0 !important;
}
.root > div > .nav-tabs .nav-link:hover {
  /* border: none !important; */
  border-top: none;
  border-left: none;
  border-right: none;
  /* border-bottom: 4px solid #830c81; */
}
.root > div > .nav {
  flex-wrap: nowrap !important;
  overflow-y: hidden;
}
.root > div > .nav-tabs .nav-link {
  width: 220px;
  display: flex;
  justify-content: center;
  @media (max-width: 640px) {
    width: auto;
    height: 60px;
  }
}
.root-il > div > .nav-tabs .nav-link {
  width: 120px;
  justify-content: center;
  @media (max-width: 640px) {
    width: auto;
  }
}
/* Oveerflow */
.cust-of > div > .nav {
  overflow-x: auto !important;
}
.cust-of > div > .nav::-webkit-scrollbar {
  width: 8px !important;
  height: 12px !important;
}
.cust-of > div > .nav::-webkit-scrollbar-thumb:hover {
  background: #d6d6d6 !important;
}

.cust-of > div > .nav::-webkit-scrollbar-thumb {
  background: #d6d6d6 !important;
  border-radius: 6px !important;
}
.cust-of > div > .nav::-webkit-scrollbar-track {
  box-shadow: inset 0 0 3px #80808026 !important;
  border-radius: 6px !important;
}
.scope-padding > .card-body {
  padding-left: 0%;
  padding-right: 0%;
  padding-top: 0%;
  padding-bottom: 0%;
}

.root-il > div > .nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  /* background: red; */
  /* border-top-width: 10px; */
  border-bottom: 4px solid #830c81;
  background-color: rgb(255, 255, 255);
  border-top: none;
  border-left: none;
  border-right: none;
  font-weight: 700;
  color: #333;
  display: flex;
  justify-content: center;
  /* background-color: antiquewhite; */
}
.root-il > div > .nav-tabs .nav-link {
  /* border: none !important; */
  border-radius: 0% !important;
}
.root-il > div > .nav-tabs .nav-item {
  flex-grow: 0 !important;
}
.root-il > div > .nav-tabs .nav-link:hover {
  /* border: none !important; */
  border-top: none;
  border-left: none;
  border-right: none;
  /* border-bottom: 4px solid #830c81; */
}
.root-il > div > .nav {
  flex-wrap: nowrap !important;
  overflow-y: hidden;
}
.aligncheck .custom-control-label {
  padding-top: 4px;
}
.cust-form-border > fieldset > div > div > input {
  border: 2px solid #830c81;
}
.form-group {
  margin-bottom: 0px !important;
}
.mt-9px {
  margin-top: 9px;
}
.fsize1rem .custom-control-label {
  font-size: 1rem;
}

.form-control:disabled,
.form-control[readonly] {
  background-color: white !important;
}
</style>
